export default __webpack_public_path__ + "static/media/tdladmin.a14f164b.png";